import type { ClassificationMark, MarkComponent } from './types';

const portionMarkBannerLineTranslations: Partial<Record<keyof ClassificationMark, MarkComponent>> =
  {
    frd: {
      portion: 'FRD',
      banner: 'FORMERLY RESTRICTED DATA',
    },
    rd: {
      portion: 'RD',
      banner: 'RESTRICTED DATA',
    },
    sap: {
      portion: 'SAR',
      banner: 'SPECIAL ACCESS REQUIRED',
    },
    accm: {
      portion: 'ACCM',
      banner: 'ACCM',
    },
    fouo: {
      portion: 'FOUO',
      banner: 'FOR OFFICIAL USE ONLY',
    },
    dcni: {
      portion: 'DCNI',
      banner: 'DOD UCNI',
    },
    cui: {
      portion: 'CUI',
      banner: 'CONTROLLED UNCLASSIFIED INFORMATION',
    },
    exercise: {
      portion: 'E',
      banner: 'EXERCISE',
    },
    displayOnly: {
      portion: 'DISPLAY ONLY',
      banner: 'DISPLAY ONLY',
    },
    relTo: {
      portion: 'REL',
      banner: 'REL',
    },
    imc: {
      portion: 'IMC',
      banner: 'IMCON',
    },
    nf: {
      portion: 'NF',
      banner: 'NOFORN',
    },
    oc: {
      portion: 'OC',
      banner: 'ORCON',
    },
    xd: {
      portion: 'XD',
      banner: 'EXDIS',
    },
    nd: {
      portion: 'ND',
      banner: 'NODIS',
    },
    pr: {
      portion: 'PR',
      banner: 'PROPIN',
    },
    fisa: {
      portion: 'FISA',
      banner: 'FISA',
    },
    waived: {
      portion: 'WAIVED',
      banner: 'WAIVED',
    },
    hvsaco: {
      portion: 'HVSACO',
      banner: 'HVSACO',
    },
    relido: {
      portion: 'RELIDO',
      banner: 'RELIDO',
    },
    sbu: {
      portion: 'SBU',
      banner: 'SBU',
    },
    sg: {
      portion: 'SG',
      banner: 'SIGMA',
    },
  };

export default portionMarkBannerLineTranslations;
